var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C7.4087 16.5 5.88258 15.8679 4.75736 14.7426C3.63214 13.6174 3 12.0913 3 10.5C3 7.8735 5.0325 5.77275 6.81975 3.8475L9 1.5L11.1802 3.8475C12.9675 5.7735 15 7.87425 15 10.5C15 12.0913 14.3679 13.6174 13.2426 14.7426C12.1174 15.8679 10.5913 16.5 9 16.5Z",
    stroke: "#007AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.e62ff7439f9fb36166b3bd63f5a1f494.svg";
export { ForwardRef as ReactComponent };